__turbopack_context__.v({
  "awards": "style-module-scss-module__JgVAca__awards",
});
